export const formatAddress = (addressValues: any) => {
    const parts: string[] = []

    if (addressValues?.addressType) {
        parts.push(addressValues?.addressType.name)
    }
    if (addressValues?.line1) {
        parts.push(addressValues.line1)
    }
    if (addressValues?.line2) {
        parts.push(addressValues.line2)
    }
    if (addressValues?.city) {
        parts.push(addressValues.city)
    }
    if (addressValues?.region) {
        parts.push(addressValues.region)
    }
    if (addressValues?.postCode) {
        parts.push(addressValues.postCode)
    }
    if (addressValues?.country) {
        parts.push(addressValues.country)
    }
    if (addressValues?.location?.name) {
        parts.push(addressValues.location.name)
    }

    return parts.join(', ')
}

export const formatedDate = (dateString: string | Date) => {
    const date = new Date(dateString)
    return date
      .toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
      .replace(/\//g, '/')
  }


  export const generateUniqueId = () => {
    return '_' + Math.random().toString(36).slice(2, 11);
  }
  export const addressTypeData = [
    {
        id: 0,
        name: 'Invoice Address', value: 'invoice'
    },
    {
        id: 1,
        name: 'Delivery Address', value: 'delivery'
    }
]

export const getUserId = () => {
  const quotedUserId = localStorage.getItem('userId') as string;
  return quotedUserId.slice(1, -1)
}